import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const RangeDescription = styled.div`
  font-size: 13px;
  color: #373e44;
  word-break: break-word;
  line-height: 18px;
  white-space: pre-line;
  margin-bottom: 10px;
`;

const RangeTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #373e44;
`;

const RangeContainer = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: ${props => (props.className === 'unpadded' ? '0' : '0 20px')};
`;

const RangeInputContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const RangeSliderInput = styled.input`
  -webkit-appearance: none;
  width: 100%;
  height: 9px;
  border-radius: 5px;
  background-image: linear-gradient(
    to right,
    ${props => props.sliderThumbColor} 0%,
    ${props => props.sliderThumbColor},
    ${props => (props.isValuePercentage ? props.value : props.value * (100 / props.max))}%,
    ${props => props.sliderBackgroundColor} ${props => props.value}%,
    ${props => props.sliderBackgroundColor} 100%
  );
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;

  :hover {
    opacity: 1;
  }

  :disabled {
    background-image: linear-gradient(to right, grey, grey);

    &::-webkit-slider-thumb {
      background: grey;
    }

    &::-moz-range-thumb {
      background: grey;
    }
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid white;
    background: ${props => props.sliderThumbColor};
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  }

  &::-moz-range-thumb {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: ${props => props.sliderThumbColor};
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  }
`;

const RangePercentage = styled.span`
  font-size: 15px;
  font-weight: 700;
  margin-left: 10px;
  color: #373e44;
`;

class RangeSlider extends Component {
  handleChange = event => {
    if (!this.props.disabled) {
      let value = parseInt(event.target.value);
      this.props.onChange(value);
    }
  };

  render() {
    const {
      className,
      value,
      title,
      description,
      disabled,
      minimum,
      maximum = 10,
      sliderBackgroundColor,
      sliderThumbColor,
      displayValue,
      isValuePercentage
    } = this.props;
    return (
      <RangeContainer className={className}>
        {title ? <RangeTitle>{title}</RangeTitle> : null}
        {description ? <RangeDescription>{description}</RangeDescription> : null}
        <RangeInputContainer>
          <RangeSliderInput
            type="range"
            value={value}
            min={minimum}
            max={maximum}
            disabled={disabled}
            onChange={this.handleChange}
            sliderBackgroundColor={sliderBackgroundColor}
            sliderThumbColor={sliderThumbColor}
            isValuePercentage={isValuePercentage}
          />
          {displayValue && (
            <RangePercentage>{isValuePercentage ? `${value}%` : value}</RangePercentage>
          )}
        </RangeInputContainer>
      </RangeContainer>
    );
  }
}

RangeSlider.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  minimum: PropTypes.number,
  maximum: PropTypes.number,
  sliderColor: PropTypes.string,
  sliderThumbColor: PropTypes.string,
  className: PropTypes.string,
  isValuePercentage: PropTypes.bool
};

RangeSlider.defaultProps = {
  disabled: false,
  displayValue: true,
  minimum: 0,
  maximum: 100,
  value: 50,
  sliderBackgroundColor: '#d3d3d3',
  sliderThumbColor: '#307fe2'
};

RangeSlider.displayName = 'RangeSlider';

export default RangeSlider;
